
const primaryList = [
    "0",
    "4",
    "8",
    "$",
    "(",
    ",",
    "@",
    "D",
    "H",
    "O",
    "S",
    "^",
    "b",
    "l",
    "p"
]
const secondaryList = [
    "1",
    "5",
    "9",
    "%",
    ")",
    "-",
    "A",
    "E",
    "I",
    "P",
    "T",
    "_",
    "c",
    "m",
    "q",
]

const toIpa = {
    "/": "ɔ",
    "0": "ɔ́",
    "1": "ɔ̀",
    "3": "aʊ",
    "4": "áʊ",
    "5": "àʊ",
    "7": "aɪ",
    "8": "áɪ",
    "9": "àɪ",
    "#": "ɑ",
    "$": "ɑ́",
    "%": "ɑ̀",
    "'": "æ",
    "(": "ǽ",
    ")": "æ̀",
    "+": "ə",
    ",": "ʌ́",
    "-": "ʌ̀",
    ":": "b",
    ";": "ʧ",
    "<": "d",
    "=": "ð",
    "?": "e",
    "@": "é",
    "A": "è",
    "C": "ər",
    "D": "ə́r",
    "E": "ə̀r",
    "G": "eɪ",
    "H": "éɪ",
    "I": "èɪ",
    "J": "f",
    "K": "g",
    "L": "h",
    "N": "ɪ",
    "O": "í",
    "P": "ì",
    "R": "i",
    "S": "i",
    "T": "i",
    "U": "ʤ",
    "V": "k",
    "W": "l",
    "X": "m",
    "Y": "n",
    "Z": "ŋ",
    "]": "oʊ",
    "^": "óʊ",
    "_": "òʊ",
    "a": "ɔɪ",
    "b": "ɔ́ɪ",
    "c": "ɔ̀ɪ",
    "d": "p",
    "e": "r",
    "f": "s",
    "g": "ʃ",
    "h": "t",
    "i": "θ",
    "k": "ʊ",
    "l": "ʊ́",
    "m": "ʊ̀",
    "o": "u",
    "p": "ú",
    "q": "ù",
    "r": "v",
    "s": "w",
    "z": "(h)w",
    "u": "j",
    "v": "z",
    "w": "ʒ",
    "x": "ʣ",
    "y": "ʦ"
}

const vowelsWithAccent = {
    "/": ["0", "1"],
    "3": ["4", "5"],
    "7": ["8", "9"],
    "#": ["$", "%"],
    "'": ["(", ")"],
    "+": [",", "-"],
    "?": ["@", "A"],
    "C": ["D", "E"],
    "G": ["H", "I"],
    "N": ["O", "P"],
    "R": ["S", "T"],
    "]": ["^", "_"],
    "a": ["b", "c"],
    "k": ["l", "m"],
    "o": ["p", "q"],
}


const ignoreAccentList = {
    "/": "/",
    "0": "/",
    "1": "/",
    "3": "3",
    "4": "3",
    "5": "3",
    "7": "7",
    "8": "7",
    "9": "7",
    "#": "#",
    "$": "#",
    "%": "#",
    "'": "'",
    "(": "'",
    ")": "'",
    "+": "+",
    ",": "+",
    "-": "+",
    ":": ":",
    ";": ";",
    "<": "<",
    "=": "=",
    "?": "?",
    "@": "?",
    "A": "?",
    "C": "C",
    "D": "C",
    "E": "C",
    "G": "G",
    "H": "G",
    "I": "G",
    "J": "J",
    "K": "K",
    "L": "L",
    "N": "N",
    "O": "N",
    "P": "N",
    "R": "R",
    "S": "R",
    "T": "R",
    "U": "U",
    "V": "V",
    "W": "W",
    "X": "X",
    "Y": "Y",
    "Z": "Z",
    "]": "]",
    "^": "]",
    "_": "]",
    "a": "a",
    "b": "a",
    "c": "a",
    "d": "d",
    "e": "e",
    "f": "f",
    "g": "g",
    "h": "h",
    "i": "i",
    "k": "k",
    "l": "k",
    "m": "k",
    "o": "o",
    "p": "o",
    "q": "o",
    "r": "r",
    "s": "s",
    "z": "z",
    "u": "u",
    "v": "v",
    "w": "w",
    "x": "x",
    "y": "y",
}

class PronUtils {

    constructor() {

    }

    static symbolsToIpa(symbol) {
        if (symbol) {
            return symbol.split('').map((ph) => {
                return {
                    withStress: toIpa[ph],
                    withoutStress: toIpa[ignoreAccentList[ph]]
                }
            })
        } else {
            return null
        }
    }

    /**
     * ASCII発音記号文字列を、IPA発音記号文字列に変換する
     *
     * @param  <string>  argument (required) ASCII発音記号文字列
     * @param  <Object>  argument (optinal) Object.isPrimary Object.isSecondaryが第i強勢かどうか
     * @return <string> アクセント記号を無視したASCII発音記号文字列
     */

    static toIpa(originalPhoneme, accentPos) {

        if (accentPos.isPrimary) {
            return toIpa[vowelsWithAccent[originalPhoneme.ph][0]]
        } else if (accentPos.isSecondary) {
            return toIpa[vowelsWithAccent[originalPhoneme.ph][1]]
        } else {
            return toIpa[originalPhoneme.ph];
        }

    }

    static toIpaWithoutStress(originalPhoneme) {
        return toIpa[ignoreAccentList[originalPhoneme.ph]]
    }


    /**
     * ASCII発音記号文字列を、アクセント記号を無視したASCII発音記号文字列に変換する
     *
     * @param  <string>  argument (required) ASCII発音記号文字列
     * @return <string> アクセント記号を無視したASCII発音記号文字列
     */

    static toAccentIgnored(phonemes) {
        return phonemes.split("").map((el) => {
            if (el === ' ') {
                return ' ';
            } else {
                return ignoreAccentList[el]
            }
        }).join("")
    }


    static isPrimaryAccent(ph) {
        return primaryList.some((el) => {
            return el === ph
        })
    }

    static isSecondaryAccent(ph) {
        return secondaryList.some((el) => {
            return el === ph
        })
    }
}

export default PronUtils;